import { initReactI18next } from 'react-i18next'
import ICU from 'i18next-icu'

import { InitI18Next } from './types'
import { applyLocizeExtraPlugins, DEFAULT_LOCIZE_SETTINGS, DEFAULT_SETTINGS } from './utils'

export const initI18Next: InitI18Next = ({ i18next, resources, isLocizeEnabled }) => {
	const icu = new ICU()
	const settings = isLocizeEnabled ? DEFAULT_LOCIZE_SETTINGS : { resources }

	if (isLocizeEnabled) {
		applyLocizeExtraPlugins(i18next)
	}

	i18next
		.use(icu)
		.use(initReactI18next)
		.init({ ...DEFAULT_SETTINGS, ...settings })
}
